import { render, staticRenderFns } from "./WechatSetting.vue?vue&type=template&id=c38c2b24&"
import script from "./WechatSetting.vue?vue&type=script&lang=js&"
export * from "./WechatSetting.vue?vue&type=script&lang=js&"
import style0 from "./WechatSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports